// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".space-block.small[data-v-681cff60]{margin-top:15px}.space-block.medium[data-v-681cff60]{margin-top:30px}.space-block.large[data-v-681cff60]{margin-top:60px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
